import { render, staticRenderFns } from "./SafeNew.vue?vue&type=template&id=b9ca5590&scoped=true&"
import script from "./SafeNew.vue?vue&type=script&lang=js&"
export * from "./SafeNew.vue?vue&type=script&lang=js&"
import style0 from "./SafeNew.vue?vue&type=style&index=0&id=b9ca5590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ca5590",
  null
  
)

export default component.exports